import type { Icon } from '../../../src/lib/types'
export const mdiFormatAlignRight: Icon = {
  "id": "format-align-right",
  "name": "Format Align Right",
  "path": "M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatAlignRight